import { AppStateEnum } from '../../../../../main/types/app-state.types.ts';
import { StepType, TaskType } from '../../../../../main/types/asset/asset.enums.ts';

import { StepGraderType } from '../../../../constants/grading.ts';

import { UserSayBaseStateChangeHandlerUtil } from './user-say-base.handler.ts';

/**
 * Specialized handler for UserPronounce and UserPronounceFast step types
 * Handles pronunciation of individual letter sounds in both normal and fast modes
 */
export class UserPronounceStateChangeHandlerUtil extends UserSayBaseStateChangeHandlerUtil {
  private static _instance: UserPronounceStateChangeHandlerUtil;

  static get instance(): UserPronounceStateChangeHandlerUtil {
    if (!UserPronounceStateChangeHandlerUtil._instance) {
      UserPronounceStateChangeHandlerUtil._instance = new UserPronounceStateChangeHandlerUtil();
    }
    return UserPronounceStateChangeHandlerUtil._instance;
  }

  protected getHandlerName(): string {
    return 'UserPronounce';
  }

  protected override async determineNextState(): Promise<AppStateEnum | null> {
    const shouldStartRecording =
      (await this.isOneOfSteps([StepType.UserPronounceFast])) || (await this.isOneOfTasks([TaskType.SoundsWriting]));
    return shouldStartRecording ? AppStateEnum.Recording : null;
  }

  protected getGraderType(): StepGraderType {
    return StepGraderType.PHONEME;
  }
}

export const getUserPronounceStateChangeHandlerUtil = (): UserPronounceStateChangeHandlerUtil =>
  UserPronounceStateChangeHandlerUtil.instance;
